<template>
    <footer class="bg-[#9d0505] text-white py-4">
        <div class="container mx-auto px-4">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <!-- Links de Navegação -->
                <div class="space-y-2">
                    <h2 class="text-xl font-bold">{{ $t('footer.links') }}</h2>
                    <div class="flex flex-col space-y-1">
                        <a href="#sobre" class="hover:text-gray-300 transition-colors">{{ $t('nav.about') }}</a>
                        <a href="#servicos" class="hover:text-gray-300 transition-colors">{{ $t('nav.services') }}</a>
                        <a href="#portfolio" class="hover:text-gray-300 transition-colors">{{ $t('nav.portfolio') }}</a>
                        <a href="#contato" class="hover:text-gray-300 transition-colors">{{ $t('nav.contact') }}</a>
                    </div>
                </div>

                <!-- Redes Sociais -->
                <div class="space-y-2">
                    <h2 class="text-xl font-bold">{{ $t('footer.social') }}</h2>
                    <div class="flex space-x-4">
                        <a href="https://instagram.com/BrunoDG" target="_blank" 
                            class="text-white hover:text-gray-300 transition-colors"
                            aria-label="Instagram">
                            <Instagram class="w-5 h-5" />
                        </a>
                        <a href="https://www.linkedin.com/company/bevel-drive" target="_blank"
                            class="text-white hover:text-gray-300 transition-colors"
                            aria-label="LinkedIn">
                            <Linkedin class="w-5 h-5" />
                        </a>
                    </div>
                </div>

                <!-- Copyright -->
                <div class="text-sm md:text-right flex items-center justify-end">
                    &copy; 2025 Bevel Drive.<br class="hidden md:block" />
                    {{ $t('footer.rights') }}
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup lang="ts">
import {
    Linkedin,
    Instagram
} from 'lucide-vue-next';
</script>
